import React, { Component } from "react"
import { Link } from "react-router-dom"
import Logo from "../images/efllogo.svg"
import AccountIcon from "../images/account-icon.svg"
import Modal from "react-modal"
import Register from "../components/Register"
import { connect } from "react-redux"
import { controlModal } from "../actions/index"
import { updateUser } from "../actions/index"
import { checkStorageForUser } from "../actions/index"
import { removeUser } from "../actions/index"
import CloseIcon from "../images/close.svg"
// import SmallCloseIcon from "../images/small-close.svg"
import { controlAlert } from "../actions/index"

class Header extends Component {
  state = {
    menuState: "nav-icon1 closed",
    menuVisible: false,
    modalOpen: false,
    modalMode: "login",
  }

  // required for screen readers
  componentWillMount() {
    Modal.setAppElement("body")
  }

  // check if user in redux store. If not despatch action to check localStorage
  componentDidMount() {
    if (Object.keys(this.props.user).length) {
      console.log("Logged in user present")
    } else {
      console.log("No logged in user in redux")
      this.props.checkStorageForUser()
    }
  }

  changeMenu = () => {
    if (this.state.menuState === "nav-icon1 closed") {
      this.setState({ menuState: "nav-icon1 open" })
      this.setState({ menuVisible: true })
    } else {
      this.setState({ menuState: "nav-icon1 closed" })
      this.setState({ menuVisible: false })
    }
  }

  openModal = () => {
    this.props.controlModal(true)
  }

  closeModal = () => {
    this.props.controlModal(false)
  }

  logOut = () => {
    this.props.removeUser()
  }

  setModalMode = (mode) => {
    this.setState({
      modalMode: mode,
    })
  }

  render() {
    return (
      <div>
        {/*this.props.alertStateBool === true ? (
          <p
            className="alert"
            style={{
              position: "absolute",
              top: 5,
              left: 10,
              right: 10,
              textAlign: "center",
              marginTop: 0,
            }}
          >
            Teaching resources for the academic year 2022-2023 have now been
            updated
            <span style={{ float: "right", paddingRight: 20 }}>
              <img
                alt=""
                className="confirm-message-close"
                src={SmallCloseIcon}
                onClick={(event) => this.props.controlAlert(false)}
              />
            </span>
          </p>
        ) : (
          <p style={{ display: "none" }}></p>
        )*/}

        {this.state.menuVisible === false ? (
          <div></div>
        ) : (
          <div className="mobile-menu">
            <div style={{ marginTop: "150px" }} className="mobile-nav">
              {/*<img style={{maxWidth: '50%', display: 'block', margin: 'auto'}} src={Logo} />*/}
              <Link className="mobile-nav-link" to="/">
                <h3 style={{ color: "white" }}>Home</h3>
              </Link>
              <Link className="mobile-nav-link" to="professional-development">
                <h3>Professional Development</h3>
              </Link>
              <Link className="mobile-nav-link" to="resources">
                <h3>Resources</h3>
              </Link>
              <Link className="mobile-nav-link" to="forum">
                <h3>Forum</h3>
              </Link>
              {/*<Link className="mobile-nav-link" to=""><h3 style={{color: 'grey'}}>Resources</h3></Link>
              <Link className="mobile-nav-link" to=""><h3 style={{color: 'grey'}}>Forum</h3></Link>*/}
            </div>

            {/* copy of top-row-nav code from desktop view */}
            <div
              className="top-row-nav"
              style={{ textAlign: "center", display: "block" }}
            >
              {Object.keys(this.props.user).length ? (
                <div className="top-row-nav-link">
                  <img
                    alt=""
                    style={{
                      display: "inline",
                      width: "20px",
                      paddingTop: 10,
                      marginRight: 10,
                    }}
                    src={AccountIcon}
                  />
                  <p style={{ display: "inline", fontSize: 16 }}>
                    You are logged in as{" "}
                    {this.props.user.user_metadata.full_name}.
                    <a
                      className="top-row-nav-link-child"
                      style={{ color: "white", fontSize: 16 }}
                      onClick={() => this.logOut()}
                    >
                      {" "}
                      Log out.
                    </a>
                  </p>
                </div>
              ) : (
                <a
                  style={{ textAlign: "center" }}
                  className="top-row-nav-link top-row-nav-link-child"
                  onClick={() => this.openModal()}
                >
                  <img
                    alt=""
                    style={{
                      display: "inline",
                      width: "20px",
                      paddingTop: 10,
                      marginRight: 10,
                    }}
                    src={AccountIcon}
                  />
                  <p style={{ display: "inline", fontSize: 16 }}>
                    Log in/Register
                  </p>
                </a>
              )}
            </div>
          </div>
        )}

        <div className="header-left">
          <div className="container">
            <div className="logo-nav-wrapper">
              <Link to="/">
                <img alt="" className="logo" src={Logo} />
              </Link>

              <div className="nav">
                <div className="top-row-nav">
                  {Object.keys(this.props.user).length ? (
                    <div className="top-row-nav-link">
                      <img
                        alt=""
                        style={{
                          display: "inline",
                          width: "20px",
                          paddingTop: 10,
                          marginRight: 10,
                        }}
                        src={AccountIcon}
                      />
                      <p style={{ display: "inline", fontSize: 16 }}>
                        You are logged in as{" "}
                        {this.props.user.user_metadata.full_name}.
                        <a
                          className="top-row-nav-link-child"
                          style={{ color: "white", fontSize: 16 }}
                          onClick={() => this.logOut()}
                        >
                          {" "}
                          Log out.
                        </a>
                      </p>
                    </div>
                  ) : (
                    <a
                      className="top-row-nav-link top-row-nav-link-child"
                      onClick={() => this.openModal()}
                    >
                      <img
                        alt=""
                        style={{
                          display: "inline",
                          width: "20px",
                          paddingTop: 10,
                          marginRight: 10,
                        }}
                        src={AccountIcon}
                      />
                      <p style={{ display: "inline", fontSize: 16 }}>
                        Log in/Register
                      </p>
                    </a>
                  )}
                </div>

                <div className="bottom-row-nav">
                  <Link className="nav-link" to="/">
                    <p className="nav-child">Home</p>
                  </Link>
                  <Link className="nav-link" to="/professional-development">
                    <p className="nav-child">Professional Development</p>
                  </Link>
                  <Link className="nav-link" to="/resources">
                    <p className="nav-child">Teaching Resources</p>
                  </Link>
                  <Link className="nav-link" to="/forum">
                    <p className="nav-child">Forum</p>
                  </Link>
                  {/*<p style={{color: 'grey'}} className="nav-link">Resources</p>
                  <p style={{color: 'grey'}} className="nav-link">Forum</p>*/}
                </div>
              </div>
              {/* end nav */}

              <div
                className={this.state.menuState}
                onClick={() => this.changeMenu()}
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
            {/* end logo-nav-wrapper */}
          </div>
          {/* end container */}
        </div>
        {/* end header-left */}

        <Modal isOpen={this.props.modalState} contentLabel="Modal">
          <img
            alt=""
            src={CloseIcon}
            style={{ float: "right", width: 40 }}
            onClick={() => this.closeModal()}
          />

          <div style={{ textAlign: "center", marginTop: 100 }}>
            <button
              style={{ marginRight: 10 }}
              onClick={() => this.setModalMode("login")}
              className={
                this.state.modalMode === "login"
                  ? "purple-button"
                  : "hollow-purple-button"
              }
            >
              Log in
            </button>
            <button
              style={{ marginLeft: 10 }}
              onClick={() => this.setModalMode("register")}
              className={
                this.state.modalMode === "register"
                  ? "purple-button"
                  : "hollow-purple-button"
              }
            >
              Register
            </button>

            <Register modalMode={this.state.modalMode} />
          </div>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    modalState: state.modalState,
    alertStateBool: state.alertState,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    controlModal: (bool) => dispatch(controlModal(bool)),
    updateUser: (user) => dispatch(updateUser(user)),
    checkStorageForUser: () => dispatch(checkStorageForUser()),
    removeUser: () => dispatch(removeUser()),
    controlAlert: (bool) => dispatch(controlAlert(bool)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/components/Header.js